import mixpanel from "mixpanel-browser"

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_PUBLIC_TOKEN

export const initializeMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token not configured. Using a bogus value.")
    mixpanel.init("DEVELOPMENT")
    mixpanel.disable()
    return
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: {
      pageview: "full-url",
      click: true,
      input: true,
      scroll: true,
      submit: true,
      capture_text_content: true,
      // mixpanel-browser dead-click tracker crashes (still in 2.79.0).
      dead_click: false,
    },
    debug: import.meta.env.DEV,
  })
}
